import React from 'react'
import {Field} from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";


const GeneralForm = ({ element }) => (

    <div>
        <Field type="text" name="name" customlabel="Nom de la spécialité" component={CustomInputTextComponent} required/>
    </div>


)

export default GeneralForm